import React from 'react';
import { components } from 'react-select';
import _get from 'lodash/get';

import { UiKit } from 'components';

export default function SelectDropdownIndicator(props) {
  const isOpen = _get(props, 'selectProps.menuIsOpen', false);

  return (
    <components.DropdownIndicator {...props}>
      <UiKit.Dropdown.Indicator
        isOpen={isOpen}
        hasValue={props.hasValue}
        isDisabled={props.isDisabled}
      />
    </components.DropdownIndicator>
  );
}
